export default {
  theme: {
    configViewer: {
      baseFontSize: 16,
      typographyExample: 'The quick brown fox jumps over the lazy dog.'
    }
  }
}
